import React, { useEffect } from "react";
import Chip from "@mui/material/Chip";
import { Field } from "react-final-form";
// import makeStyles from '@mui/styles/makeStyles';
import TextField from "@mui/material/TextField";
import Downshift from "downshift";
import PropTypes from "prop-types";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import { isArray } from "class-validator";

// const useStyles = makeStyles(theme => ({
//   chip: {
//     margin: theme.spacing(0.5, 0.25)
//   }
// }));

export default function UiTagsInput({ ...props }) {
     //   const classes = useStyles();
     const { selectedTags, placeholder, tags,onClick, ...other } = props;
     const [inputValue, setInputValue] = React.useState("");
     const [selectedItem, setSelectedItem] = React.useState([]);

     useEffect(() => {
          setSelectedItem(props.tags);
     }, [props.tags]);

     useEffect(() => {
          selectedTags(selectedItem);
     }, [selectedItem, selectedTags]);

     function handleKeyDown(event) {
          
          if (event.key === "Enter") {
               const newSelectedItem = [...selectedItem];
               const duplicatedValues = newSelectedItem.indexOf(
                    event.target.value.trim(),
               );

               if (duplicatedValues !== -1) {
                    setInputValue("");
                    return;
               }
               if (!event.target.value.replace(/\s/g, "").length) return;

               newSelectedItem.push(event.target.value.trim());
               setSelectedItem(newSelectedItem);
               setInputValue("");
          }
          if (
               selectedItem.length &&
               !inputValue.length &&
               event.key === "Backspace"
          ) {
               setSelectedItem(selectedItem.slice(0, selectedItem.length - 1));
          }
     }
     function handleChange(item) {
          let newSelectedItem = [...selectedItem];
          if (newSelectedItem.indexOf(item) === -1) {
               newSelectedItem = [...newSelectedItem, item];
          }
          setInputValue("");
          setSelectedItem(newSelectedItem);
     }

     const handleDelete = (item) => () => {
          const newSelectedItem = [...selectedItem];
          newSelectedItem.splice(newSelectedItem.indexOf(item), 1);
          setSelectedItem(newSelectedItem);
     };

     function handleInputChange(event) {
          setInputValue(event.target.value);
     }

  
     return (
         
                         <>
                              <Downshift
                                   id="downshift-multiple"
                                   inputValue={inputValue}
                                   onChange={handleChange}
                                   selectedItem={selectedItem}
                                   
                              >
                                   {({ getInputProps }) => {
                                        const {
                                             onBlur,
                                             onChange,
                                             ...inputProps
                                        } = getInputProps({
                                             onKeyDown: handleKeyDown,
                                             placeholder,
                                        });
                                        return (
                                             <div>
                                                  <TextField
                                                  
                                                       InputProps={{
                                                            startAdornment:
                                                                 isArray(
                                                                      selectedItem,
                                                                 ) &&
                                                                 selectedItem.map(
                                                                      (
                                                                           item,
                                                                      ) => (
                                                                           <Chip
                                                                                key={
                                                                                     item
                                                                                }
                                                                                tabIndex={
                                                                                     -1
                                                                                }
                                                                                label={
                                                                                     item
                                                                                }
                                                                                onDelete={handleDelete(
                                                                                     item,
                                                                                )}
                                                                           />
                                                                      ),
                                                                 ),
                                                            onBlur,
                                                            onChange: (
                                                                 event,
                                                            ) => {
                                                                 handleInputChange(
                                                                      event,
                                                                 );
                                                                 onChange(
                                                                      event,
                                                                 );

                                                                 // propsInput.input.onChange(
                                                                 //      event,
                                                                 // );
                                                            },
                                                       }}
                                                       {...other}
                                                       {...inputProps}
                                                       // onChange={() => {}}

                                                       // {...input}
                                                       // {...props}
                                                  />
                                             </div>
                                        );
                                   }}
                              </Downshift>
                         </>
     )
            
}

UiTagsInput.defaultProps = {
     tags: [],
};
UiTagsInput.propTypes = {
     selectedTags: PropTypes.func.isRequired,
     tags: PropTypes.arrayOf(PropTypes.string),
};
